import React from "react";
import Layout from "./common/Layout";
import GetPayAccount from "./GetPayAccount";

const ApplyAccountPage = () => {
  return (
    <Layout>
      <GetPayAccount />
    </Layout>
  );
};

export default ApplyAccountPage;
